import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SellerDeliveryTime from '../seller_delivery_time';
import {trackTime} from '../../utils/tracking.js';
import '@fiverr/i18n/singleton';
import './style.scss';

class ListViewInfo extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            platforms: null,
            skills: null
        };

        this.startTime = Date.now();
    }

    componentWillMount() {
        const platforms = this.props.platforms && this.props.platforms.length ? this.props.platforms.join(', ') : null,
            skills = this.props.skills && this.props.skills.length ? this.props.skills.slice(0, 4).join(', ') : null;

        if (!platforms && !skills) {
            return;
        }

        this.setState({platforms, skills});
        trackTime('list-view-info-component-will-mount', this.startTime, this.props.cardType);
    }

    componentDidMount() {
        trackTime('list-view-info-component-did-mount', this.startTime, this.props.cardType);
    }

    render() {
        const { platforms, skills } = this.state,
            { avgDeliveryTime } = this.props;

        return (
            <div className="list-view-info">
                {platforms && platforms.length ? <p><span>{i18n.t('list_view_info.platform')}</span> {platforms}</p> : null}
                {skills && skills.length ? <p><span>{i18n.t('list_view_info.expertise')}</span> {skills}</p> : null}
                {avgDeliveryTime ? <SellerDeliveryTime deliveryTime={avgDeliveryTime}/> : null}
            </div>
        );
    }
}

ListViewInfo.propTypes = {
    cardType: PropTypes.string,
    platforms: PropTypes.array,
    skills: PropTypes.array,
    avgDeliveryTime: PropTypes.number
};

export default ListViewInfo;



// WEBPACK FOOTER //
// ./src/shared/list_view_info/index.js